<template>
  <div id="land" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div
      style="
        display: flex;
        width: 100%;
        height: 38px;
        border-bottom: 1px solid #acacac;
        align-items: center;
      "
    >
      <img class="titile-logo" src="@/assets/images/titile-logo.png" alt="" />
      <div class="change-xzqh-type">热门地块</div>
    </div>
    <!-- <div class="land-line"></div> -->
    <div class="land-box" ref="matterContent" v-show="hotLandList.length">
      <div
        class="land-box-li"
        v-for="(item, index) in hotLandList"
        :key="index"
        @click="
          $router.push({
            path: '/land/detail',
            query: { id: item.id },
          })
        "
      >
        <div class="land-box-li-t">
          <el-tooltip
            class="item"
            effect="light"
            :content="item.name || item.code"
            placement="bottom"
          >
            <div class="land-box-li-title">{{ item.name || item.code }}</div>
          </el-tooltip>

          <el-tooltip
            class="item"
            :content="item.industryTypeName"
            placement="bottom"
            effect="light"
          >
            <div class="land-box-li-t-t1" v-if="item.industryTypeName">
              {{ item.industryTypeName }}
            </div>
          </el-tooltip>
        </div>
        <div class="center-l-li">
          <div class="li-img">
            <i
              class="iconfont icon-zichanchanyeyongdijixiaopingjiayuguanli"
            ></i>
          </div>
          <div class="center-l-li-r">{{ item.typeName }}</div>
        </div>
        <div class="center-l-li">
          <div
            style="display: flex; align-items: center"
            v-if="item.supplyPeriod == 1"
          >
            <div class="li-img">
              <img src="@/assets/images/tl1.png" alt="" style="width: 16px" />
            </div>
            <div class="center-l-li-r" style="color: rgb(2, 214, 74)">
              立等可供
            </div>
          </div>
          <div
            style="display: flex; align-items: center"
            v-if="item.supplyPeriod == 3"
          >
            <div class="li-img">
              <img src="@/assets/images/tl3.png" alt="" style="width: 16px" />
            </div>
            <div class="center-l-li-r" style="color: (73, 122, 255)">
              计划可供
            </div>
          </div>
          <div
            style="display: flex; align-items: center"
            v-if="item.supplyPeriod == 4"
          >
            <div class="li-img">
              <img src="@/assets/images/tl2.png" alt="" style="width: 16px" />
            </div>
            <div class="center-l-li-r" style="color: rgb(255, 174, 17)">
              规划可用
            </div>
          </div>
        </div>
        <div class="center-l-li1">
          <div>
            <span class="center-l-li1-1">{{ item.area }}</span>
            <span class="center-l-li1-2">亩</span>
          </div>
          <div
            class="land-box-li-btn"
            @click="
              $router.push({
                path: '/land/detail',
                query: { id: item.id },
              })
            "
          >
            详情
          </div>
        </div>
      </div>
    </div>
    <div class="land-no" v-if="!hotLandList.length">
      <!-- 暂无数据 -->
      <div class="land-no-img">
        <img src="../../../assets/images/home/no-data1.png" alt="" />
      </div>
    </div>

    <el-image-viewer
      :url-list="srcList"
      :initial-index="viewerIndex"
      :on-close="closeViewer"
      v-if="viewerShow"
    ></el-image-viewer>
  </div>
</template>
<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { hotLandList } from "@/api/setting/investment";

export default {
  components: {
    ElImageViewer,
  },
  props: {
    county: {
      type: String,
      default: "",
    },
    recommended: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenIndexWidth: null,
      hotLandList: [],
      loading: false,
      viewerShow: false,
      srcList: [],
      viewerIndex: 0,
      initialIndex: 0, //轮播下标
      xzqhList: [],
      type: "0",
      current: 1,
      landTotal: 0,
      frist: true,
    };
  },
  watch: {
    county(val) {
      this.frist = true;
      this.landTotal = 0;
      this.current = 1;
      this.hotLandList = [];
      this.getLands();
    },
    recommended(val) {
      this.getLands();
    },
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    this.getLands();
  },
  methods: {
    //type:0.全部 1.推荐  2.新增
    changeType(val) {
      this.type = val;
      this.recommended = this.type;
      this.getLands();
      // this.$emit("changeType", val);
    },
    //查询地块
    async getLands() {
      this.loading = true;
      let { data: res } = await hotLandList({
        recommended: this.recommended == 0 ? "" : this.recommended,
        county: this.county,
        size: 12,
        current: this.current,
      });
      if (res.success) {
        let list = res.data.records;
        this.landTotal = res.data.total;

        list.forEach((item) => {
          if (item.pronounceImages) {
            let imgUrl =
              item.pronounceImages.length > 0
                ? systemConfig.imgServer +
                  systemConfig.imgApi +
                  item.pronounceImages[0].filePath
                : null;
            this.$set(item, "imgUrl", imgUrl);
            item.pronounceImages = item.pronounceImages
              ? item.pronounceImages
              : [];
            if (item.pronounceImages.length) {
              item.pronounceImages.forEach((itemFile) => {
                this.$set(
                  itemFile,
                  "url",
                  systemConfig.imgServer +
                    systemConfig.imgApi +
                    itemFile.filePath
                );
              });
            }
          }
        });

        this.hotLandList = [...this.hotLandList, ...list];
        this.loading = false;

        if (this.frist) {
          this.$nextTick(() => {
            let el = this.$refs.matterContent;
            let offsetHeight = el.offsetHeight;
            el.onscroll = () => {
              let scrollTop = el.scrollTop;
              let scrollHeight = el.scrollHeight;

              if (offsetHeight + scrollTop - scrollHeight >= 0) {
                let pageCount = Math.ceil(this.landTotal / 12);
                let nowPage = this.current + 1;
                if (nowPage <= pageCount) {
                  this.current = this.current + 1;
                  this.getLands();
                }
              }
            };
            this.frist = false;
          });
        }
      }
    },

    //替换大图
    changeImgUrl(index, imgIndex) {
      this.hotLandList[index].imgUrl =
        this.hotLandList[index].pronounceImages[imgIndex].url;
    },

    //关闭查看大图
    closeViewer() {
      this.viewerShow = false;
    },

    //上一张
    changeCarouselLeft() {
      this.$refs.carousel.prev();
    },
    //下一张
    changeCarouselRight() {
      this.$refs.carousel.next();
    },
    //查看大图
    showViewer(index) {
      this.hotLandList[index].pronounceImages.forEach((item) => {
        this.srcList.push(item.url);
      });
      this.viewerShow = true;
    },
  },
};
</script>
<style scoped>
/* #land {
  width: 100%;
  height: 100%;
} */
.land-box {
  width: 100%;
  height: calc(100% - 42px);
  overflow: auto;
  /* display: flex;*/
  flex-grow: 1;
  -ms-overflow-style: none;
  /* Internet Explorer 10+ */
  scrollbar-width: none;
  /* Firefox */
}

.land-box::-webkit-scrollbar {
  width: 4px;
  height: 8px;
  background-color: #cfe0f5;
  border-radius: 4px;
}

.land-box::-webkit-scrollbar-thumb {
  background-color: rgba(113, 155, 199, 0.7);
  /* background-color: rgba(8, 49, 94, 0.7); */
  border-radius: 4px;
}

.land-line {
  height: 1px;
  width: 100%;
  background: #acacac;
  margin-bottom: 10px;
}

.change-xzqh-type {
  display: flex;
  font-weight: 600;
  /* margin-bottom: 10px; */
  font-size: 1.25rem;
  padding-left: 10px;
}

.change-xzqh-type-span {
  font-size: 0.95rem;
  padding: 0 5px;
  cursor: pointer;
}

.act_color {
  color: #409eff;
}

.land-no {
  width: 100%;
  height: calc(100% - 42px);
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.land-no-img {
  width: 216px;
  height: 120px;
}

.land-no-img > img {
  width: 100%;
  height: 100%;
}

.land-box-li {
  width: 30%;
  height: 28%;
  margin: 1%;
  flex: 0 0 auto;
  display: inline-block;
  box-shadow: -2px -2px 18px 4px #f5f5f5;
  border: 1px solid #e7e7e7;
  padding: 5px 2px;
  cursor: pointer;
}

.land-box-li-img {
  height: 120px;
  width: 100%;
}

.land-box-li-img > img {
  width: 100%;
  height: 100%;
}

.land-box-li-btn {
  background: #f39400;
  color: #fff;
  border-radius: 20px;
  height: 21px;
  line-height: 21px;
  padding: 0 15px;
  font-size: 0.85rem;
  text-align: center;
  cursor: pointer;
}

.land-box-li-t {
  width: 100%;
  display: flex;
  align-items: center;
}

.land-box-li-t-t1 {
  width: 76px;
  padding: 0 2px;
  border-radius: 4px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border: 1px solid #409eff;
  color: #409eff;
  font-size: 0.85rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.land-box-li-title {
  color: #105ab5;
  font-size: 1.05rem;
  font-weight: 600;
  padding: 5px 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.center-l-li {
  display: flex;
  padding: 5px 10px;
}

.center-l-li1 {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  color: red;
}

.center-l-li1-1 {
  font-size: 1.05rem;
  font-weight: 600;
}

.center-l-li1-2 {
  padding-left: 3px;
  font-size: 0.75rem;
}

.li-img {
  width: 14px;
  height: 16px;
  color: #3d87cb;
}

.li-img > img {
  width: 100%;
  height: 100%;
}

/* .center-l-li:last-child {
  padding-bottom: 0;
} */
.center-l-li-r {
  padding-left: 10px;
  font-size: 0.95rem;
  font-weight: bold;
  color: #7c7c7c;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.titile-logo {
  width: 40px;
  height: 20px;
}
</style>
